export const getCurrentStep = basepath =>
  parseInt(window.location.pathname.replace(basepath, ""))

export const canViewStep = (step, lastReachedStep) => {
  if (step <= 2) return true
  return lastReachedStep >= step - 1
}

export const getLastReachedStep = ({ answers, activityId, startupName }) => {
  const lastReachedStep = findLastReachedStep({
    answers,
    activityId,
    startupName,
  })
  return lastReachedStep
}

const findLastReachedStep = ({ answers, activityId, startupName }) => {
  let step = 0

  // step 1 is startupName
  if (startupName === "") return step
  step = 2

  // step 3 is activity
  if (activityId === "" || activityId === 0) return step
  step = 3

  // step 3 is intro to personality questions

  // step 4-11 (questions [1-8]) are personnality questions
  for (let i = 1; i <= 8; i++) {
    let nextStep = i + 4
    if (answers[`_${i}`] !== null) step = nextStep
    else return step
  }

  // step 12 is intro to marketing questions

  // step 13-15 (questions [9-11]) are marketing questions
  for (let i = 9; i <= 11; i++) {
    let nextStep = i + 5
    if (answers[`_${i}`] !== null) step = nextStep
    else return step
  }

  return step
}

export const hasCompletedQuestionnaire = ({ answers }) =>
  findLastReachedStep(answers) === 16

// redirect to next question if questionnaire was started
// otherwise redirect to questionnaire intro
export const getRedirectStep = lastReachedStep => {
  if (lastReachedStep > 2) return lastReachedStep + 1
  return ""
}
